import React from 'react'
import {graphql} from "gatsby";
import useDistributorQuery from '../../../hooks/use-distributor-query';
import DistributorMap from '../../distributor-map';
import DistributorCard from '../../cards/distributor';
import Select from 'react-select'
import { Search } from '../../icons'
import sal from "sal.js";

const DistributorArchive = () => {
  const distributors = useDistributorQuery();
  const [state, setState] = React.useState({});
  const [filteredDistributors, setFilteredDistributors] = React.useState(distributors);

  let groups = [
    { label: 'All', value: '' },
    { label: 'Bidfood', value: 'bidfood' },
    { label: 'Campbells', value: 'campbells' },
    { label: 'Countrywide', value: 'countrywide' },
    { label: 'Nafda', value: 'nafda' },
    { label: 'PFD', value: 'pfd' },
  ]

  let states = [
    { label: 'All', value: '' },
    { label: 'ACT', value: 'act' },
    { label: 'NSW', value: 'nsw' },
    { label: 'NT', value: 'nt' },
    { label: 'QLD', value: 'qld' },
    { label: 'SA', value: 'sa' },
    { label: 'TAS', value: 'tas' },
    { label: 'VIC', value: 'vic' },
    { label: 'WA', value: 'wa' },
  ]

  const handleChange = (e) => {
    const { name, checked } = e.target;
    setState({ ...state, [name]: checked });
  };

  const handleSelectChange = (option, field) => {
    let newState = {};
    switch (field && field.action) {
      case 'select-option':
        newState[field.name] = option;
        break;
      default:
        const { name, value } = option.currentTarget;
        newState[name] = value;
        break;
    }
    setState({ ...state, ...newState }, filterDistributors);
  };

  const filterDistributors = () => {
    let filtered = distributors.slice();
    if (state.search_location && state.search_location !== '') {
      setFilteredDistributors(filtered);
      return;
    } else {
      if (state.aus_state) {
        if (state.aus_state.value !== '') {
          filtered = filtered.filter(d => d.state.toLowerCase() === state.aus_state.value.toLowerCase());
        }
      }
      if (state.group) {
        if (state.group.value !== '') {
          filtered = filtered.filter(d => d.group === state.group.value);
        }
      }
      if (state.search_name && state.search_name !== '') {
        const searchName = state.search_name?.toLowerCase();
        filtered = filtered.filter(d => 
          d.title.toLowerCase().includes(searchName)
        );
      }
      if (state.search_location && state.search_location !== '') {
        const searchLocation = state.search_location?.toLowerCase();
        filtered = filtered.filter(d => 
          d.address.toLowerCase().includes(searchLocation) ||
          d.postcode.includes(searchLocation)
        );
      }
      if (state.wholesaler) {
        filtered = filtered.filter(d => d.wholesaler === true);
      }
      if (state.retailer) {
        filtered = filtered.filter(d => d.retailer === true);
      }
    }
    setFilteredDistributors(filtered);
  }

  React.useEffect(() => {
    filterDistributors();
  }, [state]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const searchLocation = e.target.search_location?.value;
    const searchName = e.target.search_name?.value;
    setState({ ...state, search_location: searchLocation, search_name: searchName });
  }

  const handleNameChange = (e) => {
    if (e.keyCode === 8 && e.target.value?.length === 1) {
      setState({ ...state, search_name: null });
    }
  }

  const handleInputChange = (e) => {
    if (e.keyCode === 8 && e.target.value?.length === 1) {
      setState({ ...state, search_location: null });
    }
  }
  
  return (
    <section className='distributors'>
      <div className='distributors__inner'>
        <form className='distributor__filter filter' onSubmit={(e) => handleSubmit(e)} data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
          <div className='filter__select'>
            <Select
                options={states}
                onChange={handleSelectChange}
                openMenuOnFocus={true}
                id="aus_state"
                name="aus_state"
                value={state.aus_state}
                placeholder='State'
                className="react-select-container"
                classNamePrefix="react-select"
                isSearchable={false}
            />
          </div>
          <div className='filter__select'>
            <Select
                options={groups}
                onChange={handleSelectChange}
                openMenuOnFocus={true}
                id="group"
                name="group"
                value={state.group}
                placeholder='Group'
                className="react-select-container"
                classNamePrefix="react-select"
                isSearchable={false}
            />
          </div>
          <div className='filter__input'>
            <input type='text' id='search_name' name='search_name' placeholder='Search by name' onKeyDown={(e) => handleNameChange(e)}/>
            <button type='submit'>
              <Search/>
            </button>
          </div>
          <div className='filter__input'>
            <input type='text' id='search_location' name='search_location' placeholder='Search by Suburb or Postcode' onKeyDown={(e) => handleInputChange(e)}/>
            <button type='submit'>
              <Search/>
            </button>
          </div>
          <div className='filter__checkboxes'>
            <div className='filter__checkbox'>
              <input type='checkbox' id='wholesaler' name='wholesaler' onChange={handleChange}/>
              <label htmlFor='wholesaler'>Wholesaler</label>
            </div>
            <div className='filter__checkbox'>
              <input type='checkbox' id='retailer' name='retailer' onChange={handleChange}/>
              <label htmlFor='retailer'>Retailer</label>
            </div>
          </div>
        </form>
        <div className='distributors__map'>
          <DistributorMap distributors={distributors} setFilteredDistributors={setFilteredDistributors} filteredDistributors={filteredDistributors}
            ausState={state.aus_state} searchLocation={state.search_location} />
        </div>
        <div className='distributors__items'>
          {filteredDistributors.map((distributor, index) => (
            <div key={index} className='distributors__item'>
              <DistributorCard distributor={distributor}/>
            </div>
          ))}
          {filteredDistributors.length === 0 && (
            <div className='distributors__empty'>
              <p>No distributors found that match your search criteria.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default DistributorArchive

export const query = graphql`
  fragment DistributorArchiveProps on DatoCmsDistributorArchive {
    ... on DatoCmsDistributorArchive {
      id
    }
  }
`